import $ from 'jquery';
import {component} from "@reduct/component";

import app from '../../assembler';

@component()
class OffCanvas {
	constructor() {
		this.$menuTop = $('.buttonLine--top');
		this.$menuMiddle = $('.buttonLine--middle');
		this.$menuBottom = $('.buttonLine--bottom');

		$(this.getElement())
			.add($('.navigationOverlay [data-select="toggle"]'))
			.on('click', event => {
				event.preventDefault();
				this.toggleMenu();
			});
	}

	toggleMenu() {
		$('.navigationOverlay').toggleClass('isVisible');
		$('.metaNavigationWrapper').toggleClass('expanded');
		$('body').toggleClass('onOverlayed');

		this.$menuTop.toggleClass('buttonLine--top--click');
		this.$menuMiddle.toggleClass('buttonLine--middle--click');
		this.$menuBottom.toggleClass('buttonLine--bottom--click');
	}
}

app.register(OffCanvas, 'OffCanvas');
